import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { CssBaseline } from "@mui/material";
import "react-big-calendar/lib/css/react-big-calendar.css";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "@redux";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "styled-components";
import { theme, installDebugLogger } from "@utils";

installDebugLogger();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      await navigator.serviceWorker.ready;
      console.log("Firebase messaging service worker ready");
    } catch (err) {
      console.error("Failed to register messaging service worker", err);
    }
  });
}

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <React.Fragment>
                <CssBaseline />
                <ThemeProvider theme={theme}>
                    <PersistGate loading={null} persistor={persistor}>
                        <App />
                    </PersistGate>
                </ThemeProvider>
                <CssBaseline />
            </React.Fragment>
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
